import { render } from "./fullscreenVideo.vue?vue&type=template&id=1044542a"
import script from "./fullscreenVideo.vue?vue&type=script&lang=js"
export * from "./fullscreenVideo.vue?vue&type=script&lang=js"

import "./fullscreenVideo.vue?vue&type=style&index=0&id=1044542a&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__